$(function() {

var hieghtThreshold = $(".ozone-images-with-text").offset().top;

if ($(window).width() < 767) {
var hieghtThreshold_end  = $(".ozone-images-with-text").offset().top + $(".ozone-images-with-text").height();
}else{
var hieghtThreshold_end  = $(".ozone-images-with-text").offset().top + $(".ozone-images-with-text").height() - 200 ;
}

  
$(window).scroll(function() {
    var scroll = $(window).scrollTop();
    if (scroll >= hieghtThreshold && scroll <=  hieghtThreshold_end ) {
       setTimeout(function() {
        $('.title_1').addClass('active');
          }, 10);
       setTimeout(function() {
       $('.title_2').addClass('active');
          }, 400);
          setTimeout(function() {
       $('.title_3').addClass('active');
             }, 800);
      
    } else {
      $('.title_3').removeClass('active');       
       $('.title_1').removeClass('active');
      $('.title_2').removeClass('active');
    }
  });
})